import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Am venit sceptic și am rămas surprins. Nu mi s-a dat o dietă, ci un sistem care are logică. E prima dată în 10 ani când am slăbit și nu m-am gândit să trișez, pentru că pur și simplu nu mai am pofte dezordonate.',
  name: 'Andrei M.',
  role: 'CEO, Startup Tech'
}, {
  quote: 'Medicii îmi spuneau că e stres și să mă odihnesc. Radu mi-a arătat în date că feritina mea era la pământ și tiroida mea avea nevoie de ajutor. Acum dorm 7 ore, am energie pentru copii și nu mai am nevoie de 3 cafele ca să funcționez.',
  name: 'Elena D.',
  role: 'Director Marketing'
}, {
  quote: 'Sunt avocat. Cer dovezi, nu promisiuni. Radu mi-a prezentat mecanismele biologice cu precizia unui expert tehnic. Am văzut datele înainte și după. Nu există altă concluzie logică: sistemul funcționează. Acum și eu funcționez.',
  name: 'Mihai P.',
  role: 'Avocat Senior'
}, {
  quote: 'Ca medic, am fost sceptică față de biorezonanță. Dar Radu m-a tratat ca pe un coleg, nu ca pe un pacient ignorant. Mi-a arătat datele, mi-a explicat mecanismele și a adaptat tot pentru realitatea mea de gardă. Rezultatele nu mint.',
  name: 'Cristina V.',
  role: 'Medic Cardiolog'
}, {
  quote: 'Medicul meu m-a trimis cu un ultimatum: slăbești sau începem medicația. Am ales C.E.L.O.S. înainte de pastile. La 4 luni, doctorul meu e surprins de analize. Radu mi-a salvat probabil câțiva ani buni de viață de calitate.',
  name: 'Dan R.',
  role: 'Antreprenor'
}, {
  quote: 'Trăiesc în Olanda, am acces la sistem medical excelent, și nimeni nu a identificat că feritina mea era la pământ. Radu a văzut în 30 de minute ce medicii mei n-au văzut în 2 ani. Totul s-a rezolvat cu suplimente de calitate și eliminarea unui aliment.',
  name: 'Ioana T.',
  role: 'Project Manager IT'
}];
export function Testimonials() {
  return <section className="bg-navy py-16 lg:py-20" data-id="element-232">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-montserrat font-bold text-pearl" data-id="element-235">
            Ce spun oamenii care au trecut prin Metoda C.E.L.O.S.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-236">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-white p-8 rounded-lg border border-border-subtle shadow-sm flex flex-col" data-id="element-237">
              <div className="font-lora text-6xl text-gold leading-none h-10 mb-4" data-id="element-238">
                "
              </div>
              <p className="font-lora italic text-text-medium leading-relaxed flex-1 mb-8" data-id="element-239">
                {test.quote}
              </p>

              <div className="w-full h-px bg-gold/30 mb-6" data-id="element-240"></div>

              <div className="flex items-center gap-4" data-id="element-241">
                <div className="w-12 h-12 rounded-full bg-brand-light flex items-center justify-center text-navy font-montserrat font-bold" data-id="element-242">
                  {test.name.split(' ')[0][0]}
                  {test.name.split(' ')[1]?.[0]}
                </div>
                <div data-id="element-243">
                  <p className="font-inter font-bold text-navy text-[17px]" data-id="element-244">
                    {test.name}
                  </p>
                  <p className="font-inter text-[17px] text-text-light" data-id="element-245">
                    {test.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}